
import { computed, ref, ComputedRef } from "vue";
import { useStore } from "@/store";
import { PlayerBattleProperty } from "@/store/player/types";
const store = useStore();
export default {
  name: "AttrsDialog",
  setup() {
    const Dialog = ref();
    const currentAttrs: ComputedRef<PlayerBattleProperty> = computed(() => {
      return store.getters.playerBattleProperty;
    });
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    return {
      Dialog,
      currentAttrs,
      close,
      open
    };
  }
};
